import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useInsightSessionStore = defineStore('insightSession', () => {
  const dismissedIds = ref(new Set<number>());

  function markInsightDismissed(insightId: number) {
    dismissedIds.value = new Set(dismissedIds.value).add(insightId);
  }

  return { dismissedIds, markInsightDismissed };
});
